import * as S from "./style"
import * as Style from '../../../shared/GlobalStyles/styles'
import { useCallback, useContext, useEffect, useMemo, useReducer, useRef } from "react"
import { deliveryProviderContext } from "../../../contexts/delivery"
import DeliveryServices from "../../../services/delivery"
import { useIsloading } from "../../../hooks/useIsloading"
import { getToken } from "../../../services/auth"
import { useAbortController } from "../../../hooks/useAbortController"
import { DeliveryOrdersCardsNew } from '../../../components/DeliveryOrdersCardsNew'
import { Spinner } from "react-bootstrap"
import { DarkModeContext } from "../../../contexts/darkMode"
import { DetailsDelivery } from "../../../components/DetailsDelivery"
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom.min"
import { SocketDeliveryContext } from "../../../contexts/socketDelivery"
import { useDeliveryPrintKitchen } from "../../../hooks/usePrintKitchen"
import { usePrintDelivery } from "../../../hooks/usePrintDelivery"
import { useMessage } from "../../../hooks/useMessage"
import { useValidationImportNFCE } from "../../../hooks/useValidationImportNFCE"
import { useFunctionPopUp } from "../../../hooks/useFunctionPopUp"
import { setDataObjectPrint } from "../../../functionsGlobal"
import { useModalContext } from "../../../contexts/modal"


const ACTIONS = {
    UPDATE: 'UPDATE_GENERIC'
};

export const initialState = {
    orderProgressTab: true,
    orderFinishedTab:false,
    isloading:true,
    listOrderFinished:[],
    listOrdersStatus: [],
    filterStatus:[],
    showFilterModal: false,
    makeDelivery: false,
    disabledCancel: false,
    disabled: false,
    search: '',
    statusCard: 0,
    variantCancelPosition: 0,
    variantPosition: 0,
    stablishmentStatus: false,
    withdraw: 'N',
    isLoadingFinish: false,
    isOpenDeliveryGuy: false,
    filterOptions:[
        {
            option: 'Aguardando Confimação',
            filterId: 1,
            active: false,
            istatus: 1
        },
        {
            option: 'Saiu para Entrega',
            filterId: 2,
            active: false,
            istatus: 4
            
        },
        {
            option: 'Em Preparo',
            filterId: 3,
            active: false,
            istatus: 9
        }
    ],
    variant:[
        {
            istatus:1,
            endPoint:'aceitarPedido',
            text:'Aceitar Pedido',
            color: '#fff',
            background:'#ED825C',
            next:9
        },
        {   
            istatus:9,
            endPoint:'enviarEntrega',
            text:'Enviar para entrega',
            color: '#fff',
            background:'#5765FF',
            next:4
        },
        {
            istatus:7,
            endPoint:'pedidoPronto',
            text:'Liberar para retirada',
            color: '#fff',
            background:'#2531A7',
            next:4
        },
        {
            istatus:4,
            endPoint:'finalizarDelivery',
            text:'Finalizar pedido',
            color: '#fff',
            background:'#50A773'
        },
        {   
            istatus:8,
            endPoint:'rejeitarPedido',
            text:'Rejeitar pedido',
            color: '#fff',
            background:'#C51F2A'
        },
        {
            istatus:6,
            endPoint:'excluirDelivery',
            text:'Cancelar pedido',
            color: '#fff',
            background:'#C51F2A'
        }
    
    ]

}

const themeDark = [
    {
        istatus:1,
        endPoint:'aceitarPedido',
        text:'Aceitar Pedido',
        color: '#e8e6e3',
        background:'#8f3110',
        next:9
    },
    {   
        istatus:9,
        endPoint:'enviarEntrega',
        text:'Enviar para entrega',
        color: '#e8e6e3',
        background: '#000d97',
        next:4
    },
    {
        istatus:7,
        endPoint:'pedidoPronto',
        text:'Liberar para retirada',
        color: '#e8e6e3',
        background:'#2531A7',
        next:4
    },
    {
        istatus:4,
        endPoint:'finalizarDelivery',
        text:'Finalizar pedido',
        color: '#e8e6e3',
        background:'#40875d'
    },
    {   
        istatus:8,
        endPoint:'rejeitarPedido',
        text:'Rejeitar pedido',
        color: '#e8e6e3',
        background:'#a21922'
    },
    {
        istatus:6,
        endPoint:'excluirDelivery',
        text:'Cancelar pedido',
        color: '#e8e6e3',
        background:'#a21922'
    }
]

export const storeDeliveryNew = (state, action) => {
    switch (action.type) {
        case ACTIONS.UPDATE:
            return {
                ...state, ...action.payload
            }   
        case 'RESET':
            return initialState; 
        default:
            return state;
    }
}

export const useDeliveryStateNew = () => {
    const {listInProgressOrder, setListInProgressOrder} = useContext(deliveryProviderContext);
    const {emitSocket, listenSocket, closeSocket} = useContext(SocketDeliveryContext);
    const {darkModeButton, selectedTheme, verifySisteShop }= useContext(DarkModeContext)
    const {controller} = useAbortController();
    const [state, dispatch] = useReducer(storeDeliveryNew, initialState);
    const {printKitchen: printKitchenApi} = useDeliveryPrintKitchen();
    const {printIframe, printKitchen} = usePrintDelivery();
    const {isVisibleMessage, resetMessage, showMessageModal} = useMessage();
    const {closeImportNfce, importTableToNfce, openImportNfce, validationImportNFCe, closeModalNFCE, setIsLoadingModalPrint, isLoadingModalPrint} = useValidationImportNFCE();
    const obsKitchenProducts = useRef([]);
    const {id_delivery} = useParams();
    const {
        isVisibleModal, isVisibleModalSupply,
        openModalSangria, closeModalSangria, openModalSupply, closeModalSupply
    } = useFunctionPopUp();


    const orderCardInfo = listInProgressOrder.length > 0 && state.orderProgressTab ? (
        listInProgressOrder.filter((item) => item.id === parseInt(id_delivery))
    ) : (
        state.listOrderFinished.length > 0 && state.orderFinishedTab ? (
            state.listOrderFinished.filter((item) => item.id === parseInt(id_delivery))
        ):([])
    )

    const filteredOrders = useMemo(() => state.search.length > 0 ? (listInProgressOrder.filter(item=>( 
        item.cep_entrega.includes(state.search) || 
        item.nome_cliente.includes(state.search?.toLocaleUpperCase())||
        item.snum_delivery.includes(state.search) ||
        item.cel1.includes(state.search) ||
        item.logradouro_entrega.includes(state.search.toLocaleUpperCase())
        )
    )
    ):[], [state?.search, listInProgressOrder]);

    const filteredFinishOrders = useMemo(() => state.search.length > 0 ? (state.listOrderFinished.filter(item=>( 
        item.cep_entrega.includes(state.search) || 
        item.nome_cliente.includes(state.search?.toLocaleUpperCase())||
        item.snum_delivery.includes(state.search) ||
        item.cel1.includes(state.search) ||
        item.logradouro_entrega.includes(state.search.toLocaleUpperCase())
        )
    )
    ):[], [state.search, state.listOrderFinished]);

    const filteredOrdersWithFilter =  useMemo(() => state.search.length > 0 ? state.filterStatus.filter(item=> {
        return (listInProgressOrder.filter(listIn => {
            if (listIn.istatus === item.istatus){
                listIn.cep_entrega.includes(state.search) || 
                listIn.nome_cliente.includes(state.search?.toLocaleUpperCase()) ||
                listIn.snum_delivery.includes(state.search) ||
                listIn.cel1.includes(state.search) ||
                listIn.logradouro_entrega.includes(state.search.toLocaleUpperCase())  
            }
        }) ) 
    }
    ):[], [state.search, state.filterStatus, listInProgressOrder]); 

    const matchOrdersWithFilterAndFilteredOrders =  useMemo(() => state.search.length  > 0 ? filteredOrders.filter((item, index) => {
        if(filteredOrdersWithFilter.length > 0 ){
            for (let j = 0; j < filteredOrdersWithFilter.length; j++) {
                if (item.istatus === filteredOrdersWithFilter[j].istatus) return item   
            }
        }
    })
    :[], [state.search, filteredOrders, filteredOrdersWithFilter]);


    return {
        listInProgressOrder, setListInProgressOrder,
        darkModeButton, emitSocket, listenSocket, closeSocket,
        printKitchenApi, printIframe, printKitchen, isVisibleMessage, resetMessage, showMessageModal,
        closeImportNfce, importTableToNfce, openImportNfce, validationImportNFCe, closeModalNFCE, setIsLoadingModalPrint, isLoadingModalPrint,
        controller, dispatch, isVisibleModal, isVisibleModalSupply,
        openModalSangria, closeModalSangria, openModalSupply, closeModalSupply,
        orderCardInfo, filteredOrders, filteredFinishOrders,  filteredOrdersWithFilter,matchOrdersWithFilterAndFilteredOrders, obsKitchenProducts, selectedTheme, verifySisteShop, themeDark, 
        ...state
    }
}

export const useDeliveryApiNew = (state, logic) => {
    const history = useHistory()
    const {id_delivery} = useParams()

    const GetAllOrderInProgress = useCallback( async ()=>{
        try {
            logic.updateDispatch({isloading: true});
            const service = new DeliveryServices();
            const result = await service.getAll({
                cnpj:getToken('CNPJ'),
                id_delivery:"",
                nome_endereco:"",
                telefone:"",
                cep:"",
                finalizado:"N"
            }, state.controller.signal)

            if (result.success) {
                state.setListInProgressOrder(result.data)
                logic.updateDispatch({listOrderFinished:[], isloading: false});
            }

            
        } catch (error) {   
            logic.updateDispatch({listOrderFinished:[], isloading: false});
        }
    }, [])   

    const GetAllOrderFinished = useCallback(async ()=>{
        try {
            logic.updateDispatch({isloading: true});
            const service = new DeliveryServices();
            const result = await service.getAll({
                
                    cnpj:getToken('CNPJ'),
                    id_delivery:"",
                    nome_endereco:"",
                    telefone:"",
                    cep:"",
                    finalizado:"S"
            })

            if (result.success) {
                logic.updateDispatch({listOrderFinished : result.data, isloading: false});
            }

            
        } catch (error) {   
            logic.updateDispatch({isloading: false});
        }
    }, [])

    const GetAllOrderStatus = useCallback( async () =>{
        try {
            const service  = new DeliveryServices();
            const result = await service.getAllDeliveryStatus({
                cnpj:getToken('CNPJ')
            },state.controller.signal)
    
            if (result.success) {
                logic.updateDispatch({listOrdersStatus: result.data})
            }

        } catch (error) {
        }
    }, [])

    const HandleListOrderFinished = ()=>{
        logic.updateDispatch({
            filterStatus:[],
            orderFinishedTab: true,
            orderProgressTab: false,
        })
        GetAllOrderFinished()
    }

    const HandleListOrderInProgress = ()=>{
        logic.updateDispatch({
            filterStatus:[],
            orderProgressTab: true,
            orderFinishedTab: false,
        })

        GetAllOrderInProgress()
        history.push('/Delivery');
    }

    const sendDelivery = async (id_entregador) => {
        const service = new DeliveryServices();
        const delivery = await service.SendOrderStatus(state.variant[1].endPoint,{
            cnpj:getToken('CNPJ'),
            delivery:id_delivery,
            id_entregador: id_entregador
        })
        if(delivery.success || delivery.status === '200'){
            logic.changeVariantStates(state.statusCard);
            GetAllOrderInProgress();
            GetAllOrderStatus();
            logic.updateDispatch({disabled: false});

            state.emitSocket('updateStatusDeliveryId', {
                id: getToken('CNPJ'),
                cardDelivery: {
                    id_delivery:parseInt(id_delivery),
                    statusCard: state.statusCard
                }
            })
            return;
        }

        state.setDisabled(false);
    }

    const HandleCancelOrder = useCallback(async(listInProgressOrder)=>{
        try{
            logic.updateDispatch({disabledCancel: true});
            const service = new DeliveryServices();
            const result = await service.SendOrderStatus(state.variant[state.variantCancelPosition].endPoint,{
                cnpj:getToken('CNPJ'),
                id_delivery: id_delivery,
                sistefood: 'S'
            })
            
            if(result.success ){
                const resultFilter = listInProgressOrder.filter(item => item.id === parseInt(state.id_delivery));
                state.emitSocket('count', {
                    id: getToken('CNPJ'),
                    count: listInProgressOrder.length > 0 ? listInProgressOrder.length - 1 : 0
                })


                state.emitSocket('removeCardDelivery', {
                    id: getToken('CNPJ'),
                    cardDelivery: resultFilter.length > 0 ? resultFilter[0].id : 0

                })
                GetAllOrderStatus();
                state.setIsOpen(false);
                return; 
            }
            logic.updateDispatch({disabledCancel: false})
        } catch (error) {
            logic.updateDispatch({disabledCancel: false})
            console.log(error,'error')
        }
    }, [])

    const ChangeStablishmentStatus = useCallback(async () =>{
        try {
            state.setStablishmentStatus(!state.stablishmentStatus);
            const service = new DeliveryServices();
            await service.changeStablishmentStatus({
                cnpj:getToken('CNPJ'),
                status_cardapio: state.stablishmentStatus ? 'N' : 'S'
            })
            
        } catch (error) {
            
        }
    }, [])

    const getEstablishmentStatus = useCallback(async () => {
        try {
            const service  = new DeliveryServices();
            const result   = await service.getEstablishmentStatus({
                cnpj: getToken('CNPJ')
            }); 

            state.setStablishmentStatus(result.data[0].status_cardapio === 'S' ? true: false)
        } catch (error) {
            
        }
    }, [])

    const getObsKitchen = useCallback(async (reprint) => {
        const {data = [], success = false} = await state.printKitchenApi({reprint, id_movimento: id_delivery});
        if (success && (data.retorno ==="S" && data.reimpressao ==="N")) state.obsKitchenProducts.current = [data]
        else state.obsKitchenProducts.current = [];
        return [data];
    }, [])

    const HandleVariant = useCallback(() => async(fiscal = 'N')=>{
        try {
            const service = new DeliveryServices();
            let find=[]
            let endpoint = state.variant[0].endPoint;
            if(state.statusCard > 1 ){
                find = state.variant.filter((item)=> item.istatus === state.statusCard )
                endpoint = find[0].endPoint;
            } 
            //foi igual a 1 ou seja status : aguardar confirmação

            //aqui vai fazer a condicional para saber se o botao vai ficar pronto para retirar ou enviar para a entrega
            logic.updateDispatch({disabled: true});
            if(state.withdraw === 'S' && state.statusCard === 1  ){
                const result = await service.SendOrderStatus(endpoint,{
                    cnpj:getToken('CNPJ'),
                    id_delivery: id_delivery
                })
                if(result.success){
                    await getObsKitchen('N')
                    logic.updateDispatch({disabled: false, statusCard: 9});
                    logic.changeVariantStates(9)
                    await GetAllOrderInProgress();
                    return;
                }
                logic.updateDispatch({disabled: false});

            }else if(state.statusCard === 9 ){
                if(state.withdraw === 'S'){
        
                    const result = await service.SendOrderStatus(state.variant[2].endPoint,{
                        cnpj:getToken('CNPJ'),
                        id_delivery: id_delivery
                    })

                    if(result.success || result.status === '200'){
                        logic.changeVariantStates(7)
                        GetAllOrderInProgress();
                        GetAllOrderStatus();
                        logic.updateDispatch({disabled: false});
                        return
                    }
                    logic.updateDispatch({disabled: false});
                    
                }else{
                    const resultFind =  logic.verifyIdDeliveryMan();

                    if(resultFind.id_entregador === 0){
                        logic.updateDispatch({disabled: false, isOpenDeliveryGuy: true});
                        return;
                    } 
                    state.sendDelivery(resultFind.id);

                }
                
            }else if(state.statusCard === 7){
                const result = await service.SendOrderStatus(state.variant[2].endPoint,{
                    cnpj:getToken('CNPJ'),
                    id_delivery
                });

                if(result.success || result.status === '200'){
                    logic.changeVariantStates(state.statusCard) 
                    GetAllOrderInProgress();
                    GetAllOrderStatus();
                    logic.updateDispatch({disabled: false});
                }else if(result.message === 'Produto já está como Pronto!') {
                    const result = await service.SendOrderStatus(state.variant[3].endPoint,{
                        cnpj:getToken('CNPJ'),
                        id_delivery
                    });         

                    if(result.success || result.status === '200'){
                        state.setIsOpen(false);
                        GetAllOrderInProgress();
                        GetAllOrderStatus();
                        logic.updateDispatch({disabled: false});
                    }
                    else {
                        logic.updateDispatch({disabled: false});
                        if(result.message === 'Pedido sem Forma de Pagamento!' || result.message === 'Pedido Faltando Valores!'){
                            state.link.push(`/AdicionarProdutoDelivery/FormaPagamento/${state.id_delivery}`)
                        }
                    }
                }
                
            }else{
           
                const result = await service.SendOrderStatus(endpoint,{
                    cnpj:getToken('CNPJ'),
                    id_delivery,
                    fiscal: state.validationImportNFCe() && fiscal === 'S' && state.statusCard === 4 ? 'S' : 'N',
                    sistefood:'S'
                });

                if(result.success || result.status === '200'){
                    if (state.statusCard === 1) await getObsKitchen('N')
                    if( state.statusCard === 4){
                        state.emitSocket('count', {
                            id: getToken('CNPJ'),
                            count: state.listInProgressOrder.length > 0 ? state.listInProgressOrder.length - 1 : 0
                        })

                    }

                    if(state.validationImportNFCe() && fiscal === 'S'){
                        const {Base64} = result.data
                        setDataObjectPrint(Base64)
                        state.setIsLoadingModalPrint(true);
                        state.closeImportNfce()
                        state.isVisibleMessage('Delivery finalizado com sucesso!');
                    }


                    state.statusCard === 4  ? state.setOrderEdit(false) : state.setOrderEdit(true);
                    GetAllOrderInProgress();
                    logic.changeVariantStates(state.statusCard) 
                    GetAllOrderStatus();
                    logic.updateDispatch({disabled: false});;
    
                }
                else {
                    logic.updateDispatch({disabled: false});
                    if(result.message === 'Pedido sem Forma de Pagamento!' || result.message === 'Pedido Faltando Valores!'){
                        state.isVisibleMessage(result.message, 'danger', 3000)
                        state.timeoutMessageIsNotPayment = setTimeout(() => {
                            state.link.push(`/AdicionarProdutoDelivery/FormaPagamento/${state.id_delivery}`)
                        }, 3000)
                    }

                }
            }

            state.emitSocket('updateStatusDeliveryId', {
                id: getToken('CNPJ'),
                cardDelivery: {
                    id_delivery:parseInt(id_delivery),
                    statusCard: state.statusCard
                }
            })
        } catch (error) {
            logic.updateDispatch({disabled: false});
        }
    }, [state.statusCard]);

    const handleSalveNFCE = () => HandleVariant('S')

    const handleSendDelivery = () => {
        if(state.validationImportNFCe() && state.statusCard === 4) return state.openImportNfce();
        HandleVariant();
    }

    return {
        GetAllOrderInProgress, HandleListOrderFinished, HandleListOrderInProgress, GetAllOrderStatus,
        sendDelivery, HandleCancelOrder, ChangeStablishmentStatus, getEstablishmentStatus,
        GetAllOrderFinished, getObsKitchen, HandleVariant, handleSalveNFCE,
        handleSendDelivery
    }
}

export const useDeliveryLogicNew = (state) => {
    const {id_delivery} = useParams()
    const history = useHistory()


    const updateDispatch = (newState) => state.dispatch({type: 'UPDATE_GENERIC', payload:newState})

    const findVariantPosition = useCallback((value, withdraw) =>{
        if(value === 7) updateDispatch({variantPosition: 3})
        else if (value === 9){
            if(withdraw === 'S') updateDispatch({variantPosition: 2})
            else updateDispatch({variantPosition: 1})
        }else updateDispatch({variantPosition: state.variant.map(e => e.istatus).indexOf(value)})

    }, [state.variantPosition])

    const changeCancelButton = useCallback((value)=>{
        let istatus = value;
        if(istatus !== 1) return updateDispatch({variantCancelPosition: state.variant.map(e => e.istatus).indexOf(6)})
        updateDispatch({variantCancelPosition: state.variant.map(e => e.istatus).indexOf(8)})
    },[state.variantCancelPosition])

    const changeVariantStates= (value)=>{
        switch (value) {
            case 1:                
                findVariantPosition(9, state.withdraw)
                toPrintKitchen()
                updateDispatch({variantCancelPosition: 5, statusCard: 9})
                break;

            case 9:
                if(state.withdraw === 'S'){
                    toPrintKitchen()
                    updateDispatch({
                        variantPosition:2,
                        variantCancelPosition: 5, statusCard: 7
                    })
                }
                else{
                    toPrintKitchenAndParcial()
                    updateDispatch({
                        variantPosition:3,
                        variantCancelPosition: 5, statusCard: 4
                    })
                }
                break;
            case 7:
                updateDispatch({variantPosition: 3, statusCard: 4})
                state.setVariantPosition(3)
                state.setStatusCard(4)
                toPrintKitchenAndParcial()
            break;
            default:
                break;
        }
    }

    const verifyIdDeliveryMan = () => state.listInProgressOrder.find((item) => item.id === parseInt(id_delivery));

    const ActiveModal = ()=> updateDispatch({showFilterModal: !state.showFilterModal})

    const SelectFilter = (value) =>{
        const newFilterOptions = []
        let filter =[...state.filterStatus]
        
        let indexFilter = state.filterOptions.findIndex(item=> item.filterId === value);

        if(state.filterOptions[indexFilter].active){
            state.filterOptions[indexFilter].active = !state.filterOptions[indexFilter].active;
            newFilterOptions.push(...state.filterOptions)
            let a = filter.filter(item=> item.istatus !== state.filterOptions[indexFilter].istatus)
            filter=[]
            filter.push(...a)
            updateDispatch({filterOptions: newFilterOptions, filterStatus: filter})
        }else{
            state.filterOptions[indexFilter].active = !state.filterOptions[indexFilter].active;
            newFilterOptions.push(...state.filterOptions)
            updateDispatch({filterOptions: newFilterOptions})
            const filter2 = state.listInProgressOrder.filter(t=> t.istatus === state.filterOptions[indexFilter].istatus);

            if(filter.length <= state.filterStatus.length){
                filter.push(...filter2)
                updateDispatch({filterStatus: filter})
            }
        }
    }

    const toPrintKitchenAndParcial = () =>{ 
        state.printIframe({payment:state.orderCardInfo[0]?.forma_pagamento, clientInfo:state.orderCardInfo})
    };

    const toPrintKitchen = () =>{ 
        if(state.obsKitchenProducts?.current?.length === 0) return;
        const iframe = document.querySelector("iframe").contentWindow;
        iframe.document.querySelector('body').innerHTML = state.printKitchen(false, [], state.obsKitchenProducts.current);
        iframe.focus();
        iframe.print();
    };

    const openMakeDelivery=()=>{
        updateDispatch({makeDelivery: true})
        history.push('/Delivery/LançarDelivery')
    }

    const verifyThemeColor = ({variantPosition, darkMode=false, tag='color'}) => {
        return darkMode ? state.themeDark[variantPosition][tag] : state.variant[variantPosition][tag];
    }
    return {
        updateDispatch, findVariantPosition, changeCancelButton,
        changeVariantStates, verifyIdDeliveryMan, ActiveModal, SelectFilter, toPrintKitchenAndParcial, openMakeDelivery, verifyThemeColor
    }
}

const useDeliveryNew = () => {

    const {state, logic, api} = useModalContext()

    useEffect(() => {
        state.listenSocket('removeCardDelivery', (data) => {
            let arrayTemp = [];
            state.setListInProgressOrder(state => {
                arrayTemp = state.filter((item) => { if( item.id !== data?.data?.cardDelivery) return item })
                return [...arrayTemp]
            })

            if (data?.data?.cardDelivery === parseInt(state.id_delivery)) state.setOrderEdit(false);
        }) 
        return () => state.closeSocket('removeCardDelivery');
    }, [state.id_delivery])

    useEffect(() => {
        state.listenSocket('addCardDelivery', (data) => { 
            state.setListInProgressOrder((state) =>[...state ,...data?.data?.card])
            // setListInProgressOrder((state) =>{
            //     if(state?.length > 0 && data?.data?.card?.length ===1) return [...state ,...data?.data?.card]
            //     else return [...data?.data?.card]
                
            // })
            api.GetAllOrderStatus();
        })

        state.listenSocket('addItemCardDelivery', (data) => {
            state.setListInProgressOrder((state) => {
                
                let arrayTemp = [];
                if(data?.data?.itemCard){
                    arrayTemp = state.map((item) => {
                        if(item.id === data?.data?.itemCard.id){
                            item = data?.data?.itemCard
                            item.delivery_produto = data?.data?.itemCard.delivery_produto
                        }
                        return item
                    })
                    return [...arrayTemp]
                }
            })
        }) 
        
        state.listenSocket('paymentDeliveryCard', (data) => {
            state.setListInProgressOrder((state) => {
                let arrayTemp = [];
                if(data?.data?.listPayment){
                    arrayTemp = state.map((item) => {
                        if(item.id === data?.data?.listPayment[0]?.id_delivery) item.forma_pagamento = [...data?.data?.listPayment]
                        // quando é o ultima forma de pagamento entra aqui;
                        if(item.id === data?.data?.listPayment) item.forma_pagamento = [];
             
                        return item
                    })
                    return [...arrayTemp]
                }
            })

        })

        state.listenSocket('removePaymentDeliveryCard', (data) => {
            state.setListInProgressOrder((state) => {
                let arrayTemp = [];
                if(data?.data?.listPayment){
                    arrayTemp = state.map((item) => {
                        if(item.id === data?.data?.listPayment[0]?.id_delivery) item.forma_pagamento = [...data?.data?.listPayment]
                        // quando é o ultima forma de pagamento entra aqui;
                        if(item.id === data?.data?.listPayment) item.forma_pagamento = [];
             
                        return item
                    })
                    return [...arrayTemp]
                }
            })

        })

        state.listenSocket('updateStatusDeliveryId', () => {
            api.GetAllOrderInProgress()
        })

        return () => {
            state.setListInProgressOrder([])
            state.closeSocket('addCardDelivery')  
            state.closeSocket('addItemCardDelivery')  
            state.closeSocket('paymentDeliveryCard')  
            state.closeSocket('updateStatusDeliveryId')  
            state.closeSocket('removePaymentDeliveryCard')  
            clearTimeout(state.timeoutMessageIsNotPayment)
        }
    }, [])

    useEffect(()=>{
        api.GetAllOrderInProgress();
        api.getEstablishmentStatus();
        api.GetAllOrderStatus();

    },[]);

    return {
        ...state, ...logic, ...api
    }
}

const DeliveryNew = (props) => {
    const {isloading, listInProgressOrder, darkModeButton, listOrderFinished,
        orderProgressTab, orderFinishedTab, HandleListOrderFinished, HandleListOrderInProgress,
        GetAllOrderStatus,
        openMakeDelivery, ActiveModal, SelectFilter,
        verifyScreenModalIsOpen, isLoadingModalPrint, closeModalNFCE,
        handleClickCloseModal, setOrderEdit, link, handleSendDelivery, handleSalveNFCE,
        variant, setStatusCard, listOrdersStatus,
        orderCardInfo, importTableToNfce, closeImportNfce,
        variantPosition, disabled, disabledCancel,
        isLoading, isLoadingFinish, isOpenDeliveryGuy,
        makeDelivery, setSearch,
        search, showFilterModal, filterOptions,
        filterStatus, filteredOrdersWithFilter,
        HandleVariant, setwithdraw, verifyThemeColor,
        findVariantPosition, changeCancelButton,
        setDisabled, setDisabledCancel,
        filteredOrders, orderEdit,
        stablishmentStatus, ChangeStablishmentStatus,
        setIsOpenDeliveryGuy, setListInProgressOrder, sendDelivery, 
        id_delivery, HandleCancelOrder, variantCancelPosition, filteredFinishOrders, 
        matchOrdersWithFilterAndFilteredOrders, showMessageModal, resetMessage, 
        isVisibleModal, isVisibleModalSupply, isVisibleMessage, toPrintKitchenAndParcial, 
        openModalSangria, closeModalSangria, openModalSupply, closeModalSupply

    } = useDeliveryNew()

    return(

        <Style.ContentContainer>
            <S.MainContent width={'60%'} position={'absolute'} padding_bottom={'45px'}>
                <S.OrderListContainer>

                    <S.OrderListTabWrapper>

                        <S.OrderInProgress orderProgress={orderProgressTab} onClick={HandleListOrderInProgress}>
                            Em andamento
                        </S.OrderInProgress>
                        
                        <S.OrderEnded orderFinished={orderFinishedTab} onClick={HandleListOrderFinished}>
                            Finalizados
                        </S.OrderEnded>
                    </S.OrderListTabWrapper>

                    {
                        isloading ? (
                            <Style.RowSpinner >
                                <Spinner animation="border" variant="primary" />
                            </Style.RowSpinner>
                        )
                        :(
                            <S.OrderList>
                                <DeliveryOrdersCardsNew data={orderProgressTab ? listInProgressOrder : listOrderFinished}/>
                            </S.OrderList>
                        )
                    }

                </S.OrderListContainer>
            </S.MainContent>

            <DetailsDelivery/>
        </Style.ContentContainer>
    )
}


export {DeliveryNew as default}